import { useEffect, useState } from 'react';

/**
 * The query string a credential-bearing landing route was opened with, read once at mount. It is
 * then dropped from the address bar and this history entry, so the credential it carries (session
 * token, OAuth key or code, hub code, reset or invite key) isn't kept in browser history or sent as
 * a Referer. Read during render, not in the caller's effect, so an effect that runs twice
 * (StrictMode) still sees it.
 *
 * replaceState bypasses react-router, whose location keeps the old query. Read the landing's params
 * from here rather than useLocation/useSearchParams, and don't merge query updates through the
 * router on that page: they would write the old query back.
 */
export function useHandoffParams(): URLSearchParams {
  const [params] = useState(() => new URLSearchParams(window.location.search));

  useEffect(() => {
    const { pathname, hash } = window.location;
    window.history.replaceState(window.history.state, '', pathname + hash);
  }, []);

  return params;
}
